import Vue from "vue";
import Router from "vue-router";

import { authGuard } from "../auth";

Vue.use(Router);

/**
 * Modify the push method of vue-router
 */
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch((err) => err);
};

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Home",
      component: () => import("../views/Home"),
      beforeEnter: authGuard,
    },
    {
      path: "/profile",
      name: "Profile",
      component: () => import("../views/Profile.vue"),
      beforeEnter: authGuard,
    },
    {
      path: "/alerts",
      name: "Alerts",
      component: () => import("../views/Alerts"),
      beforeEnter: authGuard,
    },
    {
      path: "/devices",
      name: "Devices",
      component: () => import("../views/DeviceHome"),
      beforeEnter: authGuard,
    },
    {
      path: "/device/:deviceId",
      name: "Device",
      component: () => import("../views/Device"),
      beforeEnter: authGuard,
    },
    {
      path: "/locations",
      name: "Locations",
      component: () => import("../views/LocationList"),
      beforeEnter: authGuard,
    },
    {
      path: "/location/:locationId",
      name: "Location",
      component: () => import("../views/Location"),
      beforeEnter: authGuard,
    },
    {
      path: "/poi_snapshot/:locationId",
      name: "POISnapshot",
      component: () => import("../views/Snapshot"),
      beforeEnter: authGuard,
    },
    {
      path: "/poi",
      name: "POIReport",
      component: () => import("../views/PoiReport"),
      beforeEnter: authGuard,
    },
    {
      path: "/journeys",
      name: "Journeys",
      component: () => import("../views/Journeys"),
      beforeEnter: authGuard,
    },
    {
      path: "/journey/:originId/:destinationId/:week",
      name: "Journey",
      component: () => import("../views/Journey"),
      beforeEnter: authGuard,
    },
    {
      path: "/report",
      name: "Report",
      component: () => import("../views/Reports"),
      beforeEnter: authGuard,
    },
    {
      path: "/report_fleet",
      name: "report_fleet",
      component: () => import("../views/Reports"),
      beforeEnter: authGuard,
    },
    {
      path: "/report_kpi",
      name: "report_kpi",
      component: () => import("../views/Reports"),
      beforeEnter: authGuard,
    },
    {
      path: "/assets",
      name: "Assets",
      component: () => import("../views/Assets"),
      beforeEnter: authGuard,
    },
    {
      path: "/asset/:deviceId",
      name: "asset",
      component: () => import("../views/Asset"),
      beforeEnter: authGuard,
    },
    {
      path: "/scavenger/:deviceId",
      name: "scavenger",
      component: () => import("../views/ScavengerAsset"),
      beforeEnter: authGuard,
    },
    {
      path: "/scavenger",
      name: "scavenger_assets",
      component: () => import("../views/ScavengerAssets"),
      beforeEnter: authGuard,
    },
    {
      path: "/overview",
      name: "scavenger_overview",
      component: () => import("../views/ScavengerOverview"),
      beforeEnter: authGuard,
    },
    {
      path: "/event/:deviceid/:id/:subid/:startTimestamp",
      name: "powerdata_event",
      component: () => import("../views/PowerdataEvent"),
      beforeEnter: authGuard,
    },
    /*
    {
      path: "/events",
      name: "powerdata_events",
      component: () => import("../views/PowerdataEvents"),
      beforeEnter: authGuard,
    },
    */
    {
      path: "/powercoil_analytics",
      name: "Analytics",
      component: () => import("../views/Analytics"),
      beforeEnter: authGuard,
    },
    {
      path: "/powercoil_ev",
      name: "EV_Modelling",
      component: () => import("../views/EVModelling"),
      beforeEnter: authGuard,
    },
    {
      path: "/powercoil_report",
      name: "Powercoil_Report",
      component: () => import("../views/PowerdataReports"),
      beforeEnter: authGuard,
    },
    {
      path: "/powercoil_alerts",
      name: "Powercoil_Alerts",
      component: () => import("../views/PowerdataAlerts"),
      beforeEnter: authGuard,
    },
    {
      path: "/dashboard",
      name: "Rollout_Dashboard",
      component: () => import("../views/RolloutDashboard"),
      beforeEnter: authGuard,
    },
    {
      path: "/scavenger_alerts",
      name: "Scavenger_Alerts",
      component: () => import("../views/ScavengerAlerts"),
      beforeEnter: authGuard,
    },
    {
      path: "/scavenger_health",
      name: "ScavengerHealth",
      component: () => import("../views/ScavengerHealth"),
      beforeEnter: authGuard,
    },
    {
      path: "/scavenger_health/:deviceId",
      name: "ScavengerHealthD",
      component: () => import("../views/ScavengerHealthDetails"),
      beforeEnter: authGuard,
    },
    {
      path: "/scavenger_h2",
      name: "Scavenger_H2",
      component: () => import("../views/ScavengerH2"),
      beforeEnter: authGuard,
    },
    {
      path: "/scavenger_h2/:deviceId",
      name: "Scavenger_H2D",
      component: () => import("../views/ScavengerH2Details"),
      beforeEnter: authGuard,
    },
    {
      path: "/scavenger_h2_report",
      name: "Scavenger_H2_Reports",
      component: () => import("../views/ScavengerH2Report"),
      beforeEnter: authGuard,
    },
    {
      path: "/scavenger_h2_report/:deviceId",
      name: "Scavenger_H2_Report",
      component: () => import("../views/ScavengerH2Report"),
      beforeEnter: authGuard,
    },
    {
      path: "/topology/:deviceId",
      name: "ScavengerTopology",
      component: () => import("../views/ScavengerTopology"),
      beforeEnter: authGuard,
    },
    {
      path: "/checkcoverage",
      name: "Device_Test",
      component: () => import("../views/DeviceCoverage"),
    },
    {
      path: "/coverage_checker",
      name: "Device_Coverage",
      component: () => import("../views/CoverageChecker"),
      beforeEnter: authGuard,
    },
    {
      path: "/asset_snapshot/:deviceId",
      name: "Asset_Snapshot",
      component: () => import("../views/AssetSnapshotView"),
      beforeEnter: authGuard,
    },
    {
      path: "/powercoil_report_snapshot",
      name: "Report_Snapshot",
      component: () => import("../views/PowerdataReports"),
      beforeEnter: authGuard,
    },
    {
      path: "/error",
      name: "Error",
      component: () => import("../views/Error"),
      beforeEnter: authGuard,
    },
    {
      path: "/accessdenied",
      name: "AccessDenied",
      component: () => import("../views/AccessDenied"),
    },
    {
      path: "/autocon/:coordinates",
      name: "Auto_Con",
      component: () => import("../views/AutoCon"),
      beforeEnter: authGuard,
    },
    {
      path: "/advise",
      name: "Advise",
      component: () => import("../views/AdviseDashboard"),
      beforeEnter: authGuard,
    },
    {
      path: "/estateplanning",
      name: "EstatePlanning",
      component: () => import("../components/EstatePlanningDiagram"),
      beforeEnter: authGuard,
    },
    {
      path: "/events",
      name: "EventsOverview",
      component: () => import("../views/EventsOverview"),
      beforeEnter: authGuard,
    },
  ],
});

export default router;
